import React from "react";
import Alert from "@mui/material/Alert";
import { NoItemsFound } from "../publisher/NoItemsFound";

export const Empty = () => {
  return (
    <NoItemsFound>
      <Alert severity="info">
        Game files let you store your print and play files, previous versions of the game. Whatever you need this space
        for. When you share PNP files with a publisher, they will be shared from here.
      </Alert>
    </NoItemsFound>
  );
};
